var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-listing social-media grouped-by-date",
      class: {
        hasFilter:
          _vm.filterQuery.status.length ||
          _vm.filterQuery.coordinator.length ||
          _vm.filterQuery.tag.length ||
          _vm.filterQuery.outlet.length
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "deliverable-header " },
          [
            _c("HeaderIcon", {
              attrs: {
                totalDeliverableCount: this.allDeliverablesPaginationData.total
                  ? this.allDeliverablesPaginationData.total
                  : 0,
                totalOutletCount: this.outletCount ? this.outletCount : 0,
                myWeek: _vm.myWeek,
                title: _vm.getGroupHeading,
                groupTypeTitle: _vm.getGroupType,
                campaignId: _vm.socialCampaignId,
                seriesId: _vm.socialSeriesId,
                masterDeliverableId: _vm.masterDeliverableId,
                parentDeliverableId: _vm.parentDeliverableId,
                namespace: _vm.namespace
              },
              on: { toggleExpanded: _vm.toggleExpanded }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "deliverable-block" }, [
          _c("div", { staticClass: "delv-block-resp" }, [
            _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
              _c(
                "div",
                { staticClass: "dbox-left-side dleft-inner-wrap" },
                [
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        visible: _vm.expanded,
                        id: "task-listing-collapse-" + Math.random()
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dtable" },
                        [
                          _c(
                            "div",
                            { staticClass: "dtr top-row social list-labels" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading calendar-type"
                                },
                                [_c("span", [_vm._v("Type")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dtd info-heading titles no-border-radius"
                                },
                                [_c("span", [_vm._v("Post Name")])]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "dtd info-heading message-counter"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading users" },
                                [_c("span", [_vm._v("People")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading publish-date"
                                },
                                [_c("span", [_vm._v("Posting Date")])]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.listedLanguages, function(lang) {
                                return _c(
                                  "div",
                                  { staticClass: "dtd info-heading caption" },
                                  [_c("span", [_vm._v("Post Copy")])]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading thumbnail" },
                                [_c("span", [_vm._v("Image")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading alt-text" },
                                [_c("span", [_vm._v("Alt Tag")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading languages" },
                                [_c("span", [_vm._v("Languages")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading social-network"
                                },
                                [_c("span", [_vm._v("Platforms")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading publish-status"
                                },
                                [_c("span", [_vm._v("Post Status")])]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.deliverablesArray, function(
                            deliverable,
                            index
                          ) {
                            return index != "totalOutlets" &&
                              ((deliverable.social_series.length > 0 &&
                                deliverable.is_master) ||
                                deliverable.social_series.length == 0)
                              ? _c(
                                  "div",
                                  {
                                    key: "deliverable" + index,
                                    ref: "listing-row",
                                    refInFor: true,
                                    staticClass: "dtr listing-row",
                                    class: _vm.getRowClass(deliverable, index),
                                    attrs: {
                                      "data-deliverable-id": deliverable.id
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dtd infos calendar-type"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "social-media-calendar-type"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.getCalendarTypeText(
                                                    deliverable
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.userCanEditDeliverable()
                                          ? _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  },
                                                  {
                                                    name: "click-outside",
                                                    rawName: "v-click-outside",
                                                    value: _vm.deleteDeliverableClickOutside(
                                                      deliverable.id
                                                    ),
                                                    expression:
                                                      "deleteDeliverableClickOutside(deliverable.id)"
                                                  }
                                                ],
                                                class:
                                                  "delete-bar " +
                                                  (deliverable.id ==
                                                  _vm.stripRemoveDeliverableId
                                                    ? "hovered"
                                                    : ""),
                                                style: _vm.getDeliverableSideBarStyle(
                                                  deliverable
                                                ),
                                                attrs: { title: "Delete" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.deleteDeliverableClick(
                                                      deliverable
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _c("i", {
                                                    staticClass: "fas fa-trash"
                                                  })
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dtd titles breakpoint__fix",
                                        style: _vm.infoColStyle(deliverable)
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              "deliverable-title edit-d-title",
                                            on: {
                                              click: function($event) {
                                                return _vm.clickDeliverableTitle(
                                                  deliverable
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title-text" },
                                              [
                                                _vm.showManuallyUpdatedIcon(
                                                  deliverable
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "link-icon"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-unlink"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(deliverable.title) +
                                                    " \n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mobile-task-expand-button-area"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mobile-task-exp-btn"
                                              },
                                              [
                                                _c("CollapseTaskBtn", {
                                                  attrs: {
                                                    deliverable: deliverable,
                                                    index: index,
                                                    expandAll: _vm.expanded,
                                                    namespace: _vm.namespace
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm._.filter(deliverable.customFields, {
                                        field_key: "user"
                                      }),
                                      function(field, index) {
                                        return !_vm.isMobile()
                                          ? _c(
                                              "div",
                                              {
                                                key:
                                                  "" +
                                                  deliverable.id +
                                                  field.field_id,
                                                staticClass: "dtd infos"
                                              },
                                              [
                                                _c("SocialCustomFields", {
                                                  attrs: {
                                                    customField: field,
                                                    deliverable: deliverable,
                                                    namespace: _vm.namespace
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dtd infos message-counter"
                                      },
                                      [
                                        _c("SocialPostMessageCounter", {
                                          attrs: {
                                            deliverable: deliverable,
                                            namespace: _vm.namespace
                                          },
                                          on: {
                                            clickMessageCounter: function(
                                              $event
                                            ) {
                                              return _vm.clickDeliverableComments(
                                                deliverable
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dtd infos users" },
                                      [
                                        _c("span"),
                                        _vm._v(" "),
                                        _c("DeliverableListUsers", {
                                          attrs: { deliverable: deliverable }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dtd infos publish-date" },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.formatDate(
                                                deliverable.publish_date
                                              )
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.listedLanguages, function(lang) {
                                      return _c(
                                        "div",
                                        { staticClass: "dtd infos caption" },
                                        [
                                          _c("div", {
                                            staticClass: "char-count",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getCaptionForLang(
                                                  deliverable,
                                                  lang,
                                                  true
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "caption-text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getCaptionForLang(
                                                  deliverable,
                                                  lang
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dtd infos thumbnail",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getFirstSocialPostThumbnail(
                                            deliverable
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dtd infos caption",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getFirstSocialPostAltText(
                                            deliverable
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dtd infos languages" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "info-bubbles languages"
                                          },
                                          _vm._l(
                                            deliverable.languages,
                                            function(lang, lang_idx) {
                                              return _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.html",
                                                      modifiers: {
                                                        hover: true,
                                                        html: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "languages initials badge badge-primary",
                                                  class: _vm.getLangColorClass(
                                                    lang,
                                                    deliverable
                                                  ),
                                                  attrs: {
                                                    title: _vm.getLangCodeById(
                                                      lang
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "exclude-outside-click"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getLangCodeById(
                                                            lang
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dtd infos social-networks"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "info-bubbles social-networks"
                                          },
                                          _vm._l(
                                            deliverable.social_networks,
                                            function(net, net_idx) {
                                              return _c(
                                                "span",
                                                {
                                                  class:
                                                    "social-networks initials badge badge-primary " +
                                                    _vm.getSocialNetworkTypeById(
                                                      net
                                                    ),
                                                  attrs: {
                                                    title: _vm.getSocialNetworkTypeById(
                                                      net
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    class:
                                                      "fab fa-" +
                                                      _vm.getSocialNetworkTypeById(
                                                        net
                                                      ) +
                                                      " platform-indicator"
                                                  })
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dtd infos publish-status",
                                        style: _vm.getPublishStatusStyle(
                                          deliverable.publish_status
                                        )
                                      },
                                      [
                                        _c("SocialStatusLabel", {
                                          attrs: {
                                            deliverable: deliverable,
                                            isList: true,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dtable bottom-row social" }, [
                        _c("div", { staticClass: "dtr" }, [
                          _c("div", { staticClass: "dtd filtered-text" }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.getSummaryFilterText)
                              }
                            }),
                            _vm._v(" "),
                            _vm.getSystemSetting(
                              "social_media___show_new_post_button"
                            ) || _vm.showNewPostButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-theme header-filter-btns social-group-new-post-btn",
                                    attrs: { type: "button" },
                                    on: { click: _vm.newPost }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getNewPostButtonText()
                                          )
                                        }
                                      },
                                      [_vm._v("New Post")]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary float-right fa-plus fa-fw"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }